import { render } from "./SncrModal.vue?vue&type=template&id=d8648224&scoped=true"
import script from "./SncrModal.vue?vue&type=script&lang=js"
export * from "./SncrModal.vue?vue&type=script&lang=js"

import "./SncrModal.vue?vue&type=style&index=0&id=d8648224&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8648224"]])

export default __exports__